import React from "react";
import styled from "styled-components";
import NextImage from 'next/image';
import { P1 } from "../atoms/Paragraph";
import { color } from "@styles";
import AIG from "../../public/static/companies/insurance-providers-bar/AIG.svg";
import Bupa from "../../public/static/companies/insurance-providers-bar/bupa.svg";
import daiIchiLife from "../../public/static/companies/insurance-providers-bar/dai-ichi-life.svg";
import Metlife from "../../public/static/companies/insurance-providers-bar/metlife.svg";
import Zurich from "../../public/static/companies/insurance-providers-bar/zurich.svg";
import { mobile, tablet } from "components/templates/Breakpoints";

interface Props {
  title?: string;
}

export const InsuranceProvidersBar = ({
  title = "In partnership with leading insurance providers:",
}: Props) => {
  return (
    <Container>
      <InsuranceProvidersBarText align="center">{title}</InsuranceProvidersBarText>
      <CompaniesLogos>
        <NextImage src={Bupa} alt="Bupa" />
        <NextImage src={daiIchiLife} alt="Dai-Ichi Life" />
        <NextImage src={Metlife} alt="Metlife" />
        <NextImage src={Zurich} alt="Zurich" />
      </CompaniesLogos>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 10rem;
  margin-bottom: 5rem;
  z-index: 2;

  ${tablet} {
    margin-top: 5rem;
  }

  ${mobile} {
    margin-top: 0;
  }
`;

const CompaniesLogos = styled.div<{ heroVariant?: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(p) => (p.heroVariant ? "flex-start" : "center")};
  margin: 1.5rem auto 1rem;
  column-gap: 3.75rem;
  row-gap: 2.5rem;

  svg {
    margin: 1.5rem 2.5rem;
    height: 2rem;
  }

  @media only screen and (max-width: 25rem) {
    svg {
      margin: 6vw 10vw;
      height: 8vw;
    }
  }
`;

const InsuranceProvidersBarText = styled(P1)`
  color: ${color.B1100};
  padding-top: 0;
  padding-bottom: 1.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.075rem;
`;
